import type { Feature } from './types';

type HasFeature = (allFeatures: ImmutableArray<Feature>, wanted: string) => boolean;

export const hasFeature: HasFeature = (allFeatures, wanted) => allFeatures.some(feature => feature.name === wanted);
